import * as React from 'react';
import ReportActiveTerminalsManual from './ReportsComposites/ReportActiveTerminalsManual';
import {withTranslation} from 'react-i18next';
import i18next from 'i18next';
import {ReportType} from '../../Models/EnumTypes/ReportEnumTypes';
import ActiveTerminalsReportView from "components/Raports/ReportsComposites/ActiveTerminalsReportView";

type P = {
    t?: i18next.TFunction;
};
type S = {
    //
};

class ActiveTerminalsReport extends React.Component<P, S> {
    public render() {
        const {t} = this.props;
        return (
            <div className="main__content">
                <h3 className="main__title">{t('activeTerminalsReport')}</h3>
                <div className="flex flex--wrap">
                    <div className="main__inner-left">
                        <ReportActiveTerminalsManual reportType={ReportType.ACTIVE_TERMINALS_REPORT}/>
                    </div>
                    <div className="main__inner-right main__inner-right--flex-4">
                        <ActiveTerminalsReportView/>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation('reports')(ActiveTerminalsReport as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/ActiveTerminalsReport.tsx